/**
 * SEO for the test 404 preview route (`/test/404`).
 */

import { env } from '@web/src/lib/env.client'
import { robotsMetaForEnvironment, seo } from '@web/src/lib/seo'

export type Test404PageSeoLoaderInput = Record<string, never>

export function test404PageHeadFromLoaderData(_loaderData?: Test404PageSeoLoaderInput | null | undefined) {
  const description =
    'This page does not exist or may have moved. Return home, use your browser back button, or browse Spicy Friends to find events, groups, and places.'

  return seo({
    title: `Page not found (preview) | ${env.VITE_APP_NAME}`,
    description,
    robots: robotsMetaForEnvironment({
      production: 'index, follow',
      staging: 'noindex,nofollow',
    }),
  })
}
